export const productDomCode = {
  0: "碳盘查",
  1: "碳减排",
  2: "数据看板",
  3: "区块链",
  4: "CCER",
};
export const replaceSizeWithString = (inputString) => {
  const regex = /<font size="(\d+)">(.*?)<\/font>/g;
  const replacement = (_, size, content) => {
    const newSize = Math.ceil((parseInt(size) * 5.6) / 70);
    return `<font style='font-size: ${newSize}rem'>${content}</font>`;
  };

  const result = inputString?.replace(regex, replacement);

  return result;
};
